import ReactSelect from '../ReactSelect';
import React from 'react';

export const siteTypeOptions = [
  {
    value: 'HAZARD_ASSESSMENT',
    label: 'Hazard Assessment',
  },
  {
    value: 'RECYCLED',
    label: 'Recycled',
  },
] as const;

export type WaterSiteType = (typeof siteTypeOptions)[number]['value'];
export type MultiOnChange = (value?: WaterSiteType[]) => void;
export type OnChange = (value?: WaterSiteType) => void;
export const WaterSiteTypePicker = <IsMulti extends boolean = false>({
  value,
  onChange,
  isMulti,
  isClearable = false,
}: {
  isMulti?: IsMulti;
  onChange: IsMulti extends true ? MultiOnChange : OnChange;
  value?: IsMulti extends true ? WaterSiteType[] : WaterSiteType;
  isClearable?: boolean;
}) => {
  return (
    <ReactSelect
      placeholder="site type"
      isMulti={isMulti}
      isClearable={isClearable}
      value={
        isMulti
          ? siteTypeOptions.filter((option) => value?.includes(option.value))
          : siteTypeOptions.find((option) => value === option.value)
      }
      styles={{
        menu: (base) => ({
          ...base,
          minWidth: '200px',
        }),
      }}
      onChange={(values) => {
        if (isMulti) {
          (onChange as MultiOnChange)(
            Array.isArray(values)
              ? values.length > 0
                ? values.map((value1) => value1.value as WaterSiteType)
                : undefined
              : undefined
          );
        } else {
          const value =
            (values as (typeof siteTypeOptions)[number])?.value ?? undefined;
          (onChange as OnChange)(value);
        }
      }}
      options={siteTypeOptions}
    />
  );
};
